import React from 'react';
import { Button, makeStyles, Paper } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import {
    AddToMenuController,
    IAddToMenuController,
} from '../../../../../components/manageMenu/AddToMenuInBulk/AddToMenuController';

const useStyles = makeStyles({
    root: {
        padding: '1rem 2rem',
        marginBottom: '2rem',
    },
    title: {
        fontSize: '1rem',
        fontWeight: 600,
    },
    description: {
        fontSize: '0.9rem',
        color: '#8D98B7',
    },
    statusWrapper: {
        margin: '1rem 0',
    },
    buttonWrapper: {
        display: 'flex',
        color: '#8D98B7',
    },
    addToMenuBoxDiv: {
        marginTop: '1.875rem',
    },
});

export interface IInstructiveButton {
    title: string;
    description: string | JSX.Element;
    descriptionAfter?: string | JSX.Element;
    buttonText: string;
    buttonAside?: string | JSX.Element;
    disabled: boolean;
    onClick: () => void;
    status?: React.ReactNode;
    color?: 'primary' | 'secondary' | 'default';
    AddToMenuControllerProps?: IAddToMenuController;
    isEposNow?: boolean;
}

const InstructiveButton = (props: IInstructiveButton) => {
    const classes = useStyles();
    return (
        <Paper className={classes.root}>
            {props.title && <h3 className={classes.title}>{props.title}</h3>}
            <p className={classes.description}>{props.description}</p>
            <div className={classes.buttonWrapper}>
                <Button
                    variant={'contained'}
                    onClick={props.onClick}
                    color={props.color || 'default'}
                    disabled={props.disabled}
                    endIcon={<ChevronRight />}
                >
                    {props.buttonText}
                </Button>

                {props.buttonAside}
            </div>
            {props.AddToMenuControllerProps &&
                props.isEposNow &&
                props?.AddToMenuControllerProps?.menuItemsNotInMenu.length > 0 && (
                    <div className={classes.addToMenuBoxDiv}>
                        <AddToMenuController {...props.AddToMenuControllerProps} />
                    </div>
                )}
            {props.status && <div className={classes.statusWrapper}>{props.status}</div>}
            <p className={classes.description}>{props.descriptionAfter}</p>
        </Paper>
    );
};

export default InstructiveButton;
